module.exports = __webpack_public_path__ + "img/Verbandführer_III.36082ba2.svg";